//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ifAddEdit: {
      type: Boolean,
      default: false
    },
    AddformData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    systemdata: null
  },
  data: function data() {
    return {
      formPower: {
        systemId: null,
        permissionId: null,
        permissionName: null,
        permissionDesc: null,
        permissionType: null,
        permissionStatus: null
      },
      formPowerdefault: {
        systemId: null,
        permissionId: null,
        permissionName: null,
        permissionDesc: null,
        permissionType: null,
        permissionStatus: null
      },
      rules: {
        systemId: [{
          required: true,
          message: '请选择系统名称',
          trigger: 'change'
        }],
        permissionId: [{
          validator: function validator(rule, value, callback) {
            if (/[\u4E00-\u9FA5]/g.test(value)) {
              callback(new Error('请勿输入中文'));
            } else if (value === '') {
              callback(new Error('请输入权限编号'));
            } else {
              // 校验通过
              callback();
            }
          },
          trigger: 'blur'
        }],
        permissionName: [{
          required: true,
          message: '请选择权限名称',
          trigger: 'blur'
        }],
        permissionDesc: [{
          required: true,
          message: '请输入权限描述',
          trigger: 'blur'
        }],
        permissionType: [{
          required: true,
          message: '请选择权限类型',
          trigger: 'blur'
        }]
      },
      systemname: ''
    };
  },
  created: function created() {
    if (this.ifAddEdit) {
      this.formPower = this.systemdata;
    } else {
      this.formPower = this.formPowerdefault;
    }
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('powerAddSubmit', {
        bool: false
      });
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    },
    commit: function commit() {
      var _this = this;
      if (!this.ifAddEdit) {
        delete this.formPower.permissionStatus;
      }
      this.$refs.formPower.validate(function (valid) {
        if (valid) {
          _this.$emit('powerAddSubmit', {
            bool: true,
            formData: _this.formPower
          });
        } else {
          _this.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    }
  }
};